export enum Currency {
  EUR = 'EUR',
  AED = 'AED',
  AMD = 'AMD',
  ARS = 'ARS',
  AUD = 'AUD',
  BGN = 'BGN',
  BRL = 'BRL',
  CAD = 'CAD',
  CHF = 'CHF',
  CLP = 'CLP',
  CNY = 'CNY',
  CZK = 'CZK',
  DKK = 'DKK',
  GBP = 'GBP',
  HKD = 'HKD',
  HUF = 'HUF',
  ILS = 'ILS',
  INR = 'INR',
  JPY = 'JPY',
  KRW = 'KRW',
  MAD = 'MAD',
  MOP = 'MOP',
  MXN = 'MXN',
  PKR = 'PKR',
  PLN = 'PLN',
  RON = 'RON',
  SEK = 'SEK',
  TND = 'TND',
  TWD = 'TWD',
  USD = 'USD',
  UYU = 'UYU'
}

export type CurrencyWithExchangeRate = {
  code: Currency
  valueEUR: number
}
